import { Link } from "react-router-dom";
import { Mail, Globe } from "lucide-react";
import { SITE } from "../data/siteData";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A1633] text-slate-300">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-3">
        <div>
          <img
            src="/assets/logo-footer.webp"
            alt="Cytocare Formulations — Since 2007"
            className="mb-5 h-16 w-auto rounded-xl"
          />
          <p className="text-sm leading-relaxed text-slate-400">
            {SITE.tagline} The first branded oncology molecule pharmaceutical house in Eastern India, since {SITE.founded}.
          </p>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-blue-300">
            Explore
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link data-testid="footer-link-about" to="/about" className="transition-colors hover:text-white">About Us</Link></li>
            <li><Link data-testid="footer-link-products" to="/products" className="transition-colors hover:text-white">Medicines & Products</Link></li>
            <li><Link data-testid="footer-link-therapies" to="/therapeutic-areas" className="transition-colors hover:text-white">Therapeutic Areas</Link></li>
            <li><Link data-testid="footer-link-quality" to="/quality" className="transition-colors hover:text-white">Quality & Certifications</Link></li>
            <li><Link data-testid="footer-link-vision" to="/vision-2030" className="transition-colors hover:text-white">Vision 2030</Link></li>
            <li><Link data-testid="footer-link-careers" to="/careers" className="transition-colors hover:text-white">Careers</Link></li>
            <li><Link data-testid="footer-link-contact" to="/contact" className="transition-colors hover:text-white">Contact Us</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-blue-300">
            Reach Us
          </h4>
          <ul className="space-y-2.5 text-sm">
            <li className="flex items-center gap-2.5">
              <Mail size={15} className="shrink-0 text-blue-400" />
              <a data-testid="footer-email" href={`mailto:${SITE.email}`} className="transition-colors hover:text-white">{SITE.email}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Globe size={15} className="shrink-0 text-blue-400" />
              <span data-testid="footer-website">{SITE.website}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 border-t border-white/10 pt-7 text-center text-xs text-slate-500" data-testid="footer-copyright">
        © {new Date().getFullYear()} {SITE.name} All rights reserved.
      </div>
    </div>
  </footer>
);
